import React from 'react';
import PropTypes from 'prop-types';
import { IconArrowRight } from '@tabler/icons-react';
import FeatherAlert from 'components/FeatherAlert';
import { BannerLink, IntercomLink } from './styled';

const VersionBanner = ({ memberVersionLink, isAuthenticated }) => {
  if (memberVersionLink) {
    return (
      <FeatherAlert
        variant="warning"
        action={() => window.location.assign(memberVersionLink)}
        actionText="Go to your active policy document"
        actionIcon={<IconArrowRight />}
      >
        This is the latest version of the policy.
      </FeatherAlert>
    );
  }

  return (
    <FeatherAlert variant="warning">
      This is the latest version of the policy.{' '}
      {isAuthenticated ? 'Check your' : 'If you are a member, check your'}{' '}
      <BannerLink href="/dashboard/nomad-insurance">dashboard</BannerLink> or{' '}
      <IntercomLink onClick={() => window.Intercom('showNewMessage')}>
        contact our support team
      </IntercomLink>{' '}
      to find the policy version that applies to your plan.
    </FeatherAlert>
  );
};

VersionBanner.propTypes = {
  memberVersionLink: PropTypes.string,
  isAuthenticated: PropTypes.bool
};

VersionBanner.defaultProps = {
  memberVersionLink: undefined,
  isAuthenticated: false
};

export default VersionBanner;
